import { render, staticRenderFns } from "./TagUserItem.vue?vue&type=template&id=3335f0ce&scoped=true"
import script from "./TagUserItem.vue?vue&type=script&lang=js"
export * from "./TagUserItem.vue?vue&type=script&lang=js"
import style0 from "./TagUserItem.vue?vue&type=style&index=0&id=3335f0ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3335f0ce",
  null
  
)

export default component.exports